<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="企业名称：" prop="organizationName">
        <Input
          v-model="formCustom.organizationName"
          :maxlength="50"
          clearable
          placeholder="请输入"
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="统一社会信用代码：" prop="organizationCode">
        <Input
          v-model="formCustom.organizationCode"
          :maxlength="50"
          clearable
          placeholder="请输入"
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="状态：" prop="isLock">
        <Select
          v-model="formCustom.isLock"
          clearable
          filterable
          style="width: 200px"
        >
          <Option value="0">正常使用</Option>
          <Option value="1">不可使用</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button
        >
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="addOrganization()">新增组织机构</Button>
    </div>
    <div>
      <Table
        :columns="companyColumns"
        :data="companyTableData"
        :loading="loading"
        aria-describedby=""
        aria-hidden="true"
        border @on-selection-change="selectionChange"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            size="small"
            type="text"
            @click="generateInvitationCode(row)"
          >查看
          </Button>
          <Button
            size="small"
            type="text"
            @click="editOrganization(row)"
          >编辑
          </Button
          >
          <Button
            v-if="row.isLock"
            size="small"
            type="text"
            @click="lockButton('unlock', row.organizationId)"
          >启用
          </Button>
          <Button
            v-if="!row.isLock"
            size="small"
            type="text"
            @click="lockButton('lock', row.organizationId)"
          >禁用
          </Button>
        </template>
        <template slot="isLock" slot-scope="{ row }">
          {{ row.isLock ? '不可使用' : '正常使用' }}
        </template>
      </Table>
      <Page
        ref="pages"
        :current="page"
        :total="total"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="setCurrent"
        @on-page-size-change="setPage"
      ></Page>
    </div>
    <el-dialog :visible.sync="visible" title="查看" width="730px">
      <tree :key="row.companyId" :row="row"></tree>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import tree from '@/views/organization/tree.vue'
import {companyLock, companyPage,} from "@/api/organization";

export default {
  name: "company",
  components: {
    tree,
  },
  data() {
    return {
      total: 0,
      visible: false,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustom: {
        organizationName: "",
        organizationCode: "",
        owner: '',
        industryType: "",
        countyCode: [],
        companyScale: ''
      },
      companyColumns: [
        {type: "index", title: "序号", align: "center"},
        {title: "公司名称", key: "organizationName", align: "center"},
        {title: "统一社会信用代码", key: "organizationCode", align: "center"},
        {title: "创建时间", key: "createTime", align: "center"},
        {title: "状态", slot: "isLock", key: "isLock", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
    };
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        rows.forEach((row) => {
          ids.push(row.companyId);
        });
        this.companyIds = ids.join(",");
      }
    },
    generateInvitationCode(row) {
      this.row = row
      this.visible = true
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom,
      };
      companyPage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearch();
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      companyPage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      companyPage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id;
    },
    // 锁定/解锁
    lockButton(val, id) {
      if (val === "lock") {
        this.lockMsg = "确认禁用？";
        this.isLock = true;
      } else if (val === "unlock") {
        this.lockMsg = "确认启用？";
        this.isLock = false;
      }
      this.$Modal.confirm({
        title: this.lockMsg,
        onOk: () => {
          companyLock({
            organizationId: id,
            isLock: this.isLock,
          })
            .then((res) => {
              this.$Message.success(res.data.msg)
              this.init()
            })
            .catch(() => {
              if (val === "lock") {
                this.$Message.error("禁用失败")
              } else if (val === "unlock") {
                this.$Message.error("启用失败")
              }
            });
        },
        onCancel: () => {
          if (val === "lock") {
            this.$Message.info("已取消锁定")
          } else if (val === "unlock") {
            this.$Message.info("已取消解锁")
          }
        }
      })
    },
    addOrganization() {
      this.$router.push({
        path: '/organization/organizationAdd'
      })
    },
    editOrganization(row) {
      this.$router.push({
        path: '/organization/organizationEdit',
        query: {
          organizationId: row.organizationId,
          organizationName: row.organizationName,
        }
      })
    },
  }
}
</script>
